import { useState, type FormEvent } from "react";

interface Props {
  onLogin: (secret: string) => void;
  error?: string;
}

export default function LoginPage({ onLogin, error }: Props) {
  const [secret, setSecret] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (secret.trim()) {
      onLogin(secret.trim());
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          padding: "40px 48px",
          width: 360,
          maxWidth: "90vw",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>📈</div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#1e293b" }}>
            TradingWeb
          </h1>
          <p style={{ margin: "8px 0 0", fontSize: 14, color: "#64748b" }}>
            Enter your access key to continue
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label
              htmlFor="secret"
              style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}
            >
              Access Key
            </label>
            <input
              id="secret"
              type="password"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              placeholder="Enter access key…"
              autoFocus
              style={{
                width: "100%",
                padding: "10px 12px",
                border: error ? "1.5px solid #ef4444" : "1.5px solid #e2e8f0",
                borderRadius: 8,
                fontSize: 14,
                color: "#1e293b",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
            {error && (
              <p style={{ margin: "6px 0 0", fontSize: 12, color: "#ef4444" }}>{error}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={!secret.trim()}
            style={{
              width: "100%",
              padding: "10px 0",
              background: secret.trim() ? "#3b82f6" : "#93c5fd",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 600,
              cursor: secret.trim() ? "pointer" : "not-allowed",
              transition: "background 0.15s",
            }}
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
